/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { Injectable } from '@angular/core';
import { UserDto } from 'api/models';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserHandlerService {

  private currentUser: UserDto;


  private readonly currentUserChangedSubject = new Subject<boolean>();

  currentUserChanged = this.currentUserChangedSubject.asObservable();

  constructor() { }

  setCurrentUser(user: UserDto): void {
    if (this.currentUser !== user) {
      this.currentUser = user;
      this.currentUserChangedSubject.next(!!user);
    }
  }

  getCurrentUser(): UserDto {
    return this.currentUser;
  }

  getCurrentUserId() {
    return this.currentUser ? this.currentUser.userID : null;
  }
}
